<div class="parallax_img" id="parallax_img"></div>

<portfolio-navigation></portfolio-navigation>

<main id="main">
    <div class="container coming-soon-container text-center px-md-4">
        <span>IN THE COMMUNITY</span>
        <!-- <p class="mt-4 mb-5 p-0">A learning portfolio. Designed for you. Game-changing.</p> -->
        <!-- <img class="img-fluid" src="../../../../assets/images/backgrounds/coming-soon.jpg"> -->
    </div>
    <section class="mt-5">
        <div class="container p-5">
            <a class="text-decoration-none mb-3" [routerLink]="['/user/resources/community']"><i class="fa fa-chevron-left"></i> Back to In the Community</a>
            <div
                *ngIf="videoSource !== ''"
                plyr
                [plyrOptions]="{hideControls: false}"
                [plyrPlaysInline]="true"
                [plyrSources]="videoSource"
                (plyrInit)="videoPlayer = $event"
                id="videoPlayer"
                class="embed-responsive-item mt-3"
            >
            </div>
        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </section>
</main>
